import React from "react"

export interface IGridProps extends React.HTMLAttributes<HTMLDivElement> {
    // Set the number (and the widths) of columns in the Grid container
    columns?: React.CSSProperties["gridTemplateColumns"]
    // Set the number (and the heights) of the rows in the Grid container
    rows?: React.CSSProperties["gridTemplateRows"]
    // Set areas within the Grid container
    areas?: React.CSSProperties["gridTemplateAreas"]
    // Set the size of the gap between the rows and columns in the Grid container
    gap?: React.CSSProperties["gap"]
    /**
     * Sometimes the total size of your grid might be less than the size of its Grid container.
     * In this case you can set the alignment of the grid within the grid container.
     * This property aligns the grid along the inline (row) axis.
     **/
    justifyContent?: React.CSSProperties["justifyContent"]
    /**
     * Sometimes the total size of your grid might be less than the size of its Grid container.
     * In this case you can set the alignment of the grid within the grid container.
     * This property aligns the grid along the block (column) axis.
     **/
    alignContent?: React.CSSProperties["alignContent"]
    alignItems?: React.CSSProperties["alignItems"]
    onClick?(): void
}

const Grid = React.forwardRef<HTMLDivElement, React.PropsWithChildren<IGridProps>>(({
    columns,
    rows,
    areas,
    gap,
    justifyContent,
    alignContent,
    alignItems,
    style,
    children,
    ...others
}, ref) => {
    return (
        <div
            ref={ref}
            style={{
                display: "grid",
                gridTemplateColumns: columns,
                gridTemplateRows: rows,
                gridTemplateAreas: areas,
                gap,
                justifyContent,
                alignContent,
                alignItems,
                ...style,
            }}
            {...others}>
            {children}
        </div>
    )
})

Grid.displayName = "Grid"

export default Grid
